export default __webpack_public_path__ + "static/media/placeholder2.745949e7.jpeg";